// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JIVU","title":"styles_title__3_kID","cardWrapper":"styles_cardWrapper__f3QkN"};